import React, { Suspense, lazy } from 'react'
import { Router, Route, Switch } from 'dva/router'
import { Spin } from 'antd'
import 'moment/locale/zh-cn'
import moment from 'moment'
moment.locale('zh-cn')
const MainLaytout = lazy(() => import('@/layouts/MainLaytout'))
const AccoutnLayout = lazy(() => import('@/layouts/AccoutnLayout'))
const NoticeLayout = lazy(() => import('@/layouts/NoticeLayout'))

const Home = lazy(() => import('@/pages/home'))
const NoticeDetail = lazy(() => import('@/pages/noticeDetail'))
const NoticeMessage = lazy(() => import('@/pages/message/notice'))
const ServiceMessage = lazy(() => import('@/pages/message/service'))

const Login = lazy(() => import('@/pages/account/login'))
const Register = lazy(() => import('@/pages/account/register'))
const ForgetPassword = lazy(() => import('@/pages/account/forgetPassword'))
const ChangePhone = lazy(() => import('@/pages/account/changePhone'))

const Member = lazy(() => import('@/pages/manage/member'))
const Message = lazy(() => import('@/pages/manage/message'))
const Payment = lazy(() => import('@/pages/manage/payment'))

function BasicRouter({ history, app }) {
  return (
    <Suspense
      fallback={
        <div className="suspenseLoading">
          <Spin />
        </div>
      }
    >
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/home" component={Home} />
          <Route exact path="/notice/:id" component={NoticeDetail} />
          <Route
            path="/message"
            render={() => (
              <NoticeLayout>
                <Route exact path="/message/notice" component={NoticeMessage} />
                <Route exact path="/message/service" component={ServiceMessage} />
              </NoticeLayout>
            )}
          />
          <Route
            path="/account"
            render={() => (
              <AccoutnLayout>
                <Route exact path="/account/login" component={Login} />
                <Route exact path="/account/register" component={Register} />
                <Route exact path="/account/forgetPassword" component={ForgetPassword} />
                <Route exact path="/account/changePhone" component={ChangePhone} />
              </AccoutnLayout>
            )}
          />
          <Route
            path="/manage"
            render={() => (
              <MainLaytout>
                <Route exact path="/manage/member" component={Member} />
                <Route exact path="/manage/member/:tab" component={Member} />
                <Route exact path="/manage/message" component={Message} />
                <Route exact path="/manage/payment" component={Payment} />
              </MainLaytout>
            )}
          />
        </Switch>
      </Router>
    </Suspense>
  )
}

export default BasicRouter
